import { AlignItems, Breakpoint } from "../enum-types";
import { JustifyContent } from "../justify-content";

export interface AtlGridTwoColsWithLateralProps {
    internalId: string;
    internalClassName?: string;
    internalMainClassName?: string;
    internalLateralClassName?: string;
}

export interface AtlGridOneColProps {
    internalId: string;
    internalClassName?: string;
    internalColClassName?: string;
}

export interface AtlGridTwoColsProps extends AtlGridOneColProps {
    internalCol2ClassName?: string;
}

export interface AtlGridThreeColsProps extends AtlGridTwoColsProps {
    fullHeight?: boolean;
    internalCol3ClassName?: string;
}

export interface AtlGridProps {
    stackVertically: boolean;
    inline: boolean;
    alignItems?: AlignItems;
    justifyContent?: JustifyContent;
    breakpoint?: Breakpoint
}

export interface AtlGridColProps {
    autoSizing: boolean;
    asFlex: boolean;
    colSize: number;
    alignItems?: AlignItems;
    justifyContent?: JustifyContent;
    breakpoint?: Breakpoint
}

export interface AtlGridNestedTwoColsProps {
    firstColClassName?: string;
    secondColClassName?: string;
    fullHeight: boolean;
}

export interface AtlContentHeadingGridProps {
    horizontalSpacing?: boolean;
    rightBlockFullWithOnMobile?: boolean;
}

enum AtlGridTagNames {
    Grid = 'atlantis-grid',
    GridOneCol = 'atlantis-grid-one-col',
    GridTwoCols = 'atlantis-grid-two-cols',
    GridTwoColsWithLateral = 'atlantis-grid-two-cols-with-lateral',
    GridThreeCols = 'atlantis-grid-three-cols',
    GridThreeCol = 'atlantis-grid-three-col',
    GridCol = 'atlantis-grid-col',
    ContentHeadingGrid = 'atlantis-content-heading-grid',
    InnerRow = 'atlantis-grid-inner-row',
    NestedTwoCols = 'atlantis-grid-nested-two-cols'
}

export { AlignItems, Breakpoint, JustifyContent, AtlGridTagNames };